import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateOfferMutation = createMutationHook(OffersApiClient.createOffer, {
  mutationKey: ['createOffer'],
})
